import { Controller } from "@hotwired/stimulus";

export default class DateVariableToggleController extends Controller {
  static targets = ["modeSelect", "datePickerContainer", "variableContainer", "variableSelect"];
  static values = { fieldName: String };

  toggle() {
    const mode = this.modeSelectTarget.querySelector("input[type=hidden]")?.value;
    const isVariable = mode === "variable";

    this.datePickerContainerTarget.classList.toggle("hidden", isVariable);
    this.variableContainerTarget.classList.toggle("hidden", !isVariable);

    const dateInput = this.datePickerContainerTarget.querySelector("input[type=hidden]");
    const variableInput = this.variableSelectTarget.querySelector("input[type=hidden]");

    if (dateInput) dateInput.name = isVariable ? "" : this.fieldNameValue;
    if (variableInput) variableInput.name = isVariable ? this.fieldNameValue : "";
  }
}
